export const VISA = 'visa';
export const AMEX = 'amex';
export const DINERS = 'diners';
export const MASTERCARD = 'mastercard';
export const ELO = 'elo';
